import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Grid,
} from "@mui/material";
import { Player, RoundSolve } from "./utils/MatchUtils";
import { auth } from "../config/firebase";
import RoundRow from "./RoundRow";

interface MatchSolveTableProps {
    playerSolves: {player: Player, roundSolves: RoundSolve[]},
    opponentSolves: {player: Player, roundSolves: RoundSolve[]},
    currentRound: number,
    currentSolve: number
}

const MatchSolveTable: React.FC<MatchSolveTableProps> = ({ playerSolves, opponentSolves, currentRound, currentSolve }) => {
    const currentUserId = auth.currentUser?.uid;
    //if (roundSolves.length === 0) return <Typography>No solve results found.</Typography>;

    // Group solves by round
    const groupedByRound = playerSolves.roundSolves.reduce((acc: Record<number, RoundSolve[]>, solve) => {
        if (!acc[solve.roundNumber]) {
            acc[solve.roundNumber] = [];
        }
        acc[solve.roundNumber].push(solve);
        return acc;
    }, {});

    const oppGroupedByRound = opponentSolves.roundSolves.reduce((acc: Record<number, RoundSolve[]>, solve) => {
        if (!acc[solve.roundNumber]) {
            acc[solve.roundNumber] = [];
        }
        acc[solve.roundNumber].push(solve);
        return acc;
    }, {});

    return (
        // <Container maxWidth={currentUserId == playerSolves.player.uid ? "md" : "sm"} sx={{ mt: 2 }}>
        <Grid item xs={currentUserId == playerSolves.player.uid ? 8 : 4}>
            <Typography variant="h5" gutterBottom>
                {playerSolves.player?.displayName}
            </Typography>
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell sx={{fontWeight: 600}}>Round</TableCell>
                            <TableCell sx={{fontWeight: 600}}>Best</TableCell>
                            <TableCell sx={{fontWeight: 600}}>AVG</TableCell>
                            <TableCell align="center" sx={{fontWeight: 600}}>Wins</TableCell>
                            <TableCell align="center" sx={{fontWeight: 600}}>Losses</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.keys(groupedByRound).map((val)=> (
                            <RoundRow
                                roundNumber={Number(val)}
                                solves={groupedByRound[Number(val)]}
                                opponentSolves={oppGroupedByRound[Number(val)]}
                                showScramble={currentUserId == playerSolves.player.uid}
                                currentRound={currentRound}
                                currentSolve={currentSolve}
                                adminActions={false}
                            ></RoundRow>
                        ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};

export default MatchSolveTable;
